import SessionEventProto from "../session-event-proto";
import {BUS_COMPANY_USERS_CHANGED} from "../../model2/company-user-new/@const";


export default class EventCompanyUsersDelete extends SessionEventProto {

    process() {
        if (this.isDifferentCompany()) return false;

        const companyUser = gd.session.companyUsers.get(this.data.companyId+"-"+this.data.userId);
        if (companyUser) {
            gd.session.companyUsers.remove(companyUser.id);
        } else {
            console.error("unkonown company user. can't delete");
            return
        }

        gd.modelBus.newUpdate('company-user', this.method, companyUser.id, this.data,{});
        gd.bus.triggerEvent(BUS_COMPANY_USERS_CHANGED)
    }
};



//
// module.exports = class EventCompanyUsersDelete extends EventActionProto {
//
//     constructor(sessionEvent) {
//         super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
//
//         this.method     = sessionEvent.method
//         this.fromSID    = sessionEvent.fromSID
//     }
//
//     validate() {
//         return true;
//     }
//
//     process() {
//
//         var companyUser = gd.session.companyUsers.get(this.data.companyId+"-"+this.data.userId);
//         if (companyUser) {
//             gd.session.companyUsers.remove(companyUser);
//         } else {
//             console.error("unkonown company user. can't delete");
//         }
//
//         super.process()
//
//         this._sendBusUpdate()
//     }
//
//     _sendBusUpdate() {
//         // send
//         const companyUserId = this.data.companyId+"-"+this.data.userId
//         gd.modelBus.newUpdate('company-user', this.method, companyUserId, this.data);
//     }
// };

